import React from 'react'

function TechnologyPartners() {
    return (
        <div>
            {/* start technology partners section */}
            <div className="rts-trusted-client rts-section-gap bg-client-bg-h6">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="title-area text-center">
                                <p className="pre-title">Our Technology Partners</p>
                                <h2 className="title">Platforms We Work With</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt--40">
                        <div className="col-12">
                            <div className="client-wrapper-one technology-partners-wrapper">
                                <div className="single-client">
                                    <a href="https://www.xero.com" target="_blank" rel="noopener noreferrer">
                                        <img
                                            src="assets/images/client/xero-accounting-software.png"
                                            alt="Xero Accounting Software"
                                        />
                                    </a>
                                </div>
                                <div className="single-client">
                                    <a href="https://www.sage.com" target="_blank" rel="noopener noreferrer">
                                        <img
                                            src="assets/images/client/sage.png"
                                            alt="Sage Accounting Software"
                                        />
                                    </a>
                                </div>
                                <div className="single-client">
                                    <a href="https://www.freeagent.com" target="_blank" rel="noopener noreferrer">
                                        <img
                                            src="assets/images/client/Freeagent-software.png"
                                            alt="FreeAgent Accounting Software"
                                        />
                                    </a>
                                </div>
                                <div className="single-client">
                                    <a href="https://www.hubdoc.com" target="_blank" rel="noopener noreferrer">
                                        <img
                                            src="assets/images/client/Hubdoc-Logo.png.webp"
                                            alt="Hubdoc Document Management"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end technology partners section */}
        </div>
    )
}

export default TechnologyPartners
